import React from "react";
import { ADVICE_SECTION_BY_KEY } from "../../../constants/tspAdvice";

// Coloured pill for one advice section (Best Areas, Mistakes, Challenges,
// Suggestions, Future Opportunities). Colour is never the only signal — the
// label is text.
export default function AdviceCategoryBadge({ category }) {
  const meta = ADVICE_SECTION_BY_KEY[category];
  if (!meta) return null;
  return <span className={`tsp-status-pill tsp-pill-${meta.tone}`}>{meta.label}</span>;
}
